import { ComponentPropsWithoutRef } from 'react'
import { cn } from '~shared/utils/cn'
import Image from 'next/image'

export interface OneCourseTwoDiplomasSectionProps
  extends ComponentPropsWithoutRef<'section'> {}

export const OneCourseTwoDiplomasSection = (
  props: OneCourseTwoDiplomasSectionProps
) => {
  const { className = '', ...rest } = props
  const data = [
    {
      id: 1,
      text: 'Получите два ценных диплома, потверждающих вашу квалификацию:'
    },
    {
      id: 2,
      text: 'Диплом психолога-консультанта о профессиональной переподготовке, признанный на государственном уровне.'
    },
    {
      id: 3,
      text: 'Диплом об освоении модальности, подтверждающий 500 часов изучения психотеравпевтичнского метода.'
    }
  ]
  return (
    <section
      className={cn('container container-slim pt-[40px]', className)}
      {...rest}>
      <div className='flex justify-between w-full h-[460px]'>
        <div className='max-w-[500px] h-full flex flex-col'>
          <h2 className='typo-section-heading leading-[90%]'>
            Два диплома за&nbsp;один&nbsp;курс
          </h2>
          <ul className='flex flex-col gap-[16px] pl-[16px] mt-[24px]'>
            {data.map(el => (
              <li key={el.id} className='list-disc'>
                {el.text}
              </li>
            ))}
          </ul>
          <p className='bg-[#7D5EE4] px-[24px] py-[16px] rounded-[24px] text-white  mt-auto'>
            Это откроет перед вами возможности для практики в ведущих
            онлайн-платформах и центрах, таких как Ясно, Alter, Zigmund.Online
            и других платформах, на которых работают психологи, сразу
            после окончания программы
          </p>
        </div>
        <div className='w-[50%]  relative rounded-[24px] overflow-hidden'>
          <Image
            src='/assets/imgs/psychology-course-page/two_diplomas.jpg'
            alt='Decoration'
            fill
            className='object-cover'
          />
        </div>
      </div>
    </section>
  )
}
